import React from 'react';
import {  useContext } from 'react';
import { expertContext } from '../../../../context/expertcontext';
const Steps = () => {

    const {tab,setTab} = useContext(expertContext)
 

    return (
        <div>
        <div className="process">
        <div className="process-row nav nav-tabs" id="myTab" role="tablist">
          <div className="process-step">
            <button
              className={`btn btn-circle ${tab === 1 && "tab-btn-active"}`}
              // onClick={()=>{setTab(1)}}
              type='button'
            ></button>
            <p>
              <small>
                مشخصات ملک
              </small>
            </p>
          </div>
          <div className="process-step">
          <button
          className={`btn btn-circle ${tab === 2 && "tab-btn-active"}`}
          // onClick={()=>{setTab(2)}}
          type='button'
        ></button>
            <p>
              <small>
                شرح عرصه
                <br />
              </small>
            </p>
          </div>
          <div className="process-step">
          <button
          className={`btn btn-circle ${tab === 3 && "tab-btn-active"}`}
          // onClick={()=>{setTab(3)}}
          type='button'
        ></button>
            <p>
              <small>
                مشخصات بیشتر
              </small>
            </p>
          </div>
          <div className="process-step">
          <button
          className={`btn btn-circle ${tab === 4 && "tab-btn-active"}`}
          type='button'
          // onClick={()=>{setTab(4)}}
        ></button>
            <p>
              <small>
                امتیازات
              </small>
            </p>
          </div>
          <div className="process-step">
          <button
          className={`btn btn-circle ${tab === 5 && "tab-btn-active"}`}
          type='button'
          // onClick={()=>{setTab(5)}}
        ></button>
            <p>
              <small>
                ابعاد
              </small>
            </p>
          </div>
          <div className="process-step">
          <button
          className={`btn btn-circle ${tab === 6 && "tab-btn-active"}`}
          type='button'
          // onClick={()=>{setTab(6)}}
        ></button>
            <p>
              <small>
                توضیحات
              </small>
            </p>
          </div>
          <div className="process-step">
          <button
          className={`btn btn-circle ${tab === 7 && "tab-btn-active"}`}
          type='button'
          // onClick={()=>{setTab(7)}}
        ></button>
            <p>
              <small>
                پیش نمایش
                <br />
              </small>
            </p>
          </div>
        </div>
      </div>
     
        </div>
    );
};

export default Steps;